import { createFileRoute } from "@tanstack/react-router"

import { LogbookReportPage } from "@/trips/components/mileage/logbook-report-page"

export const Route = createFileRoute("/_app-shell/logbook/report/$id")({
  head: () => ({ meta: [{ title: "Logbook report - Kestly" }] }),
  component: function LogbookReportRoute() {
    const { id } = Route.useParams()
    return <LogbookReportPage id={id} />
  },
})
